/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexDto } from '../../models/backend-capex-dto';

export interface CapexsList$Params {
  scenario_id?: number;

  /**
   * A search term.
   */
  search?: string;
}

export function capexsList(
  http: HttpClient,
  rootUrl: string,
  params?: CapexsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendCapexDto>>> {
  const rb = new RequestBuilder(rootUrl, capexsList.PATH, 'get');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendCapexDto>>;
    }),
  );
}

capexsList.PATH = '/capexs/';
